module.exports = __webpack_public_path__ + "img/xsl.751a4f50.svg";